import angular from 'angular';
import tables from './tables';

export default angular.module('scenes.tabContent.scenes.components', [tables])
  .name;
